import React, {useEffect, useState} from "react";
import {Inquiry_Popup} from "./inquiry_popUp";
import {useCallback} from "react";


export const ScrollBtn = () => {
  const [showScrollBtn, setShowScrollBtn] = useState<boolean>(false)
  const [isActive, setIsActive] = useState<boolean>(false)
  const handleLinkClick = useCallback(() => {
    window.open(
      "http://chatbot.finevu.com/",
      "_blank", // 새 창
      "width=400,height=600,noopener,noreferrer"
    );
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setShowScrollBtn(isScrolled);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  const handleScrollBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  }
  const handleClose = () => {
    setIsActive(false)
  }
  return (
    <>

      <div className="twc-chat-icon">
        <button onClick={handleLinkClick}>
          <div className="image"></div>
          <div className="text-bubble">
            <div className="text">
              Ask any questions to<br/> FINE AI CHATBOT
            </div>
          </div>
        </button>
      </div>
      <div className="btnBox">
        <div>
          {showScrollBtn &&
              <div className="active">
                  <button onClick={handleScrollTop}>topBtn</button>
                  <button onClick={handleScrollBottom}>bottomBtn</button>
              </div>
          }

          <button onClick={() => setIsActive(prev => !prev)}>
            <span>Inquiry</span>
          </button>
        </div>
      </div>

      {isActive && <Inquiry_Popup onClose={handleClose}/>}
    </>
  )
}
